import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HizmetlerPage from "../pages/hizmetler/page";
import HizmetDetayPage from "../pages/hizmetler/detay/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hizmetler",
    element: <HizmetlerPage />,
  },
  {
    path: "/hizmetler/:slug",
    element: <HizmetDetayPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
